exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-col{width:30px;white-space:nowrap;text-align:center}.pin-col{width:1px;white-space:nowrap}.type-col{width:80px;text-align:center}.notification-col{width:200px}.category-col{width:100px;text-align:center}.category-col-badge{display:flex;justify-content:flex-end;margin-right:1rem}.date-col{width:90px;text-align:center}.announcement-type{min-width:65px;display:inline-block}.announcement-state{min-width:70px;display:inline-block}\n", ""]);

// exports
